<template>
  <div class="record-table" :class="cssType">
    <div class="thead">
      <div class="tr">
        <div class="th name">
          {{ $t('accumRecharge.rewards.recordTable.name') }}
        </div>
        <div class="th details">
          {{ $t('accumRecharge.rewards.recordTable.details') }}
        </div>
        <div class="th time">
          {{ $t('accumRecharge.rewards.recordTable.time') }}
        </div>
      </div>
    </div>
    <div class="tbody">
      <div class="tr" v-for="item in props.recordList" :key="item.id">
        <div class="td name">
          <div>
            {{ item.mergePrdCount }}
          </div>
          <div>
            {{ $t('payment.product.diamond') }}
          </div>
        </div>
        <div class="td details">
          <div class="details-item" v-for="(item, index) in JSON.parse(item.propsGift)" :key="index">
            {{ item.name }}{{ $t('accumRecharge.countFuhao') }}{{ item.count }}
          </div>
        </div>
        <div class="td time">
          {{ item.createTime }}
        </div>
      </div>
    </div>
    <div class="empty-data" v-if="props.recordList.length === 0">
      {{ $t('payment.noData') }}
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import { isMobile } from '@/utils'
const cssType = isMobile ? 'mobile' : 'pc'
const props = defineProps({
  recordList: {
    type: Array,
    required: true,
  },
})
</script>

<style lang="less" scoped src="./pc_style.less"></style>
<style lang="less" scoped src="./mobile_style.less"></style>